import { CustomMap } from '@vendor/libs/maps/maps';
const _InfectionsCommonHandler = (function () {
    let infectionFeatures = null;
    const init = () => {
        const entityInput = $('[name="entity_id"]');
        const geojsonInput = $('[name="geojson"]');
        const map = CustomMap.getMap('map');
        if (!map) {
            return;
        }
        // Clear selections on entity_id change
        entityInput.change(() => {
            infectionFeatures = map.getFeatures('infections');
            if (infectionFeatures) {
                const selectedGeoJson = entityInput.find(':selected').data('geojson');
                if (selectedGeoJson) {
                    // Place feature on selected entity's geojson location
                    InfectionsMapHandler.setInfectionLocation(selectedGeoJson, true);
                }
                else {
                    geojsonInput.val('');
                    infectionFeatures.clear();
                }
            }
        });
    };
    const clearSelections = () => {
        RichSelectHandler.clear('#entity_id');
    };
    return {
        // Public functions
        init: function () {
            init();
        },
        clearSelections,
    };
})();
window.InfectionsCommonHandler = _InfectionsCommonHandler;
